import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import "./config"; // Import config to setup global fetch override
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { ProjectProvider } from "./lib/project-context";
import { installSafeConsole } from "./lib/safeConsole";

installSafeConsole();

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <ProjectProvider>
      <App />
    </ProjectProvider>
  </QueryClientProvider>,
);
// This is a manual commit to fix author email
